(() => {
      const name = 'izy-delivery-note-v3';
      if (customElements.get(name)) return;
      class IzyDeliveryNote extends HTMLElement {
        connectedCallback() {
          if (this.onVariant || this.readyObserver) return;
          const ready = () => this.querySelector('[data-izy-delivery-data]') &&
            this.querySelector('[data-izy-delivery-message]');
          if (ready()) { this.start(); return; }
          this.readyObserver = new MutationObserver(() => {
            if (!ready()) return;
            this.readyObserver.disconnect(); this.readyObserver = null;
            this.start();
          });
          this.readyObserver.observe(this, {childList: true, subtree: true});
        }
        start() {
          this.message = this.querySelector('[data-izy-delivery-message]');
          this.scope = this.closest('product-rerender, quick-buy-modal, [id^="shopify-section-"]');
          try { this.data = JSON.parse(this.querySelector('[data-izy-delivery-data]').textContent); }
          catch (_) { return; } // Keep the server-rendered message if JS cannot initialize.
          if (!this.scope || !this.data.variants) return;
          this.bindings = new Map();
          this.unavailable = new Set();
          this.propertyNames = ["properties[Αποστολή από / Dispatch from]", "properties[Αποστολή / Dispatch]", "properties[Διαθεσιμότητα / Availability]", "properties[_izy_dispatch_source_date]"];
          this.onVariant = event => {
            if (!(event.target instanceof Element) ||
                !this.scope.contains(event.target)) return;
            const variant = event.detail?.variant;
            if (!variant) { this.show(''); this.scan(); return; }
            const id = String(variant.id);
            if (!Object.prototype.hasOwnProperty.call(this.data.variants, id)) return;
            if (variant.available === false) this.unavailable.add(id);
            else this.unavailable.delete(id);
            this.show(variant.available === false ? '' : this.data.variants[id].message);
            this.scan();
          };
          document.addEventListener('variant:change', this.onVariant);
          this.observer = new MutationObserver(() => this.scan());
          this.observer.observe(this.scope, {childList: true, subtree: true});
          this.show(this.data.variants[this.data.initial]?.message || '');
          this.scan();
        }
        isProductForm(form) {
          try {
            const url = new URL(form.action, location.href);
            return url.origin === location.origin && /\/cart\/add\/?$/.test(url.pathname);
          } catch (_) { return false; }
        }
        selectedId(form) { return String(form.elements.namedItem('id')?.value || ''); }
        dispatchFields(id) {
          const data = this.unavailable.has(id) ? null : this.data.variants[id];
          if (!data?.date) return {};
          return {
            ['properties[' + data.property + ']']: data.date,
            'properties[_izy_dispatch_source_date]': data.source
          };
        }
        scan() {
          if (!this.isConnected || !this.bindings) return;
          for (const [form, binding] of this.bindings) {
            if (!this.scope.contains(form)) this.unbind(form, binding);
          }
          for (const form of this.scope.querySelectorAll('form[action]')) {
            if (!this.isProductForm(form)) continue;
            if (!this.bindings.has(form) &&
                !Object.prototype.hasOwnProperty.call(this.data.variants, this.selectedId(form))) continue;
            if (!this.bindings.has(form)) {
              const binding = {inputs: new Map()};
              for (const input of form.querySelectorAll('[data-izy-dispatch-property]')) {
                if (this.propertyNames.includes(input.name)) binding.inputs.set(input.name, input);
              }
              binding.submit = () => this.syncInput(form, binding);
              binding.formdata = event => {
                const fields = this.dispatchFields(String(event.formData.get('id') || ''));
                for (const name of this.propertyNames) {
                  const foreign = Array.from(form.elements).some(el =>
                    el.name === name && el !== binding.inputs.get(name));
                  if (foreign) continue;
                  if (fields[name]) event.formData.set(name, fields[name]);
                  else event.formData.delete(name);
                }
              };
              form.addEventListener('submit', binding.submit, true);
              form.addEventListener('formdata', binding.formdata);
              this.bindings.set(form, binding);
            }
            this.syncInput(form, this.bindings.get(form));
          }
        }
        syncInput(form, binding) {
          const fields = this.dispatchFields(this.selectedId(form));
          for (const name of this.propertyNames) {
            let input = binding.inputs.get(name);
            const foreign = Array.from(form.elements).some(el => el.name === name && el !== input);
            if (!fields[name] || foreign) {
              input?.remove(); binding.inputs.delete(name); continue;
            }
            if (!input || !form.contains(input)) {
              input = document.createElement('input');
              input.type = 'hidden'; input.name = name;
              input.setAttribute('data-izy-dispatch-property', '');
              binding.inputs.set(name, input); form.append(input);
            }
            if (input.value !== fields[name]) input.value = fields[name];
          }
        }
        show(text) {
          if (this.message.textContent !== text) this.message.textContent = text;
          this.hidden = !text;
        }
        unbind(form, binding) {
          form.removeEventListener('submit', binding.submit, true);
          form.removeEventListener('formdata', binding.formdata);
          for (const input of binding.inputs.values()) input.remove();
          this.bindings.delete(form);
        }
        disconnectedCallback() {
          this.readyObserver?.disconnect(); this.readyObserver = null;
          this.observer?.disconnect();
          if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
          for (const [form, binding] of this.bindings || []) this.unbind(form, binding);
          this.onVariant = null;
        }
      }
      customElements.define(name, IzyDeliveryNote);
    })();
  
(() => {
  const names = ['Αποστολή από / Dispatch from', 'Αποστολή / Dispatch', 'Διαθεσιμότητα / Availability', '_izy_dispatch_source_date'];
  const root = () => window.Shopify?.routes?.root || '/';
  const request = async (url, options) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url, {...options, signal: controller.signal});
      const text = await response.text();
      if (!response.ok) throw new Error('dispatch-request');
      return {text: async () => text, json: async () => JSON.parse(text), ok: true};
    } finally { clearTimeout(timeout); }
  };
  const showError = form => {
    form.querySelector('[data-izy-dispatch-error]')?.remove();
    const message = document.createElement('p');
    message.dataset.izyDispatchError = '';
    message.setAttribute('role', 'alert');
    message.textContent = form.dataset.dispatchError;
    form.append(message);
  };
  if (new URLSearchParams(location.search).has('dispatch_refresh')) {
    const form = document.querySelector('form.cart-page[data-izy-dispatch-checkout]');
    if (form) showError(form);
    const url = new URL(location.href); url.searchParams.delete('dispatch_refresh');
    history.replaceState(history.state, '', url);
  }

  const normalize = properties => Object.fromEntries(Object.entries(properties || {}).filter(([, value]) => value !== '' && value != null).sort(([a], [b]) => a.localeCompare(b)));
  const signature = items => JSON.stringify(items.map(item => [item.key, item.quantity, normalize(item.properties)]));
  const quantities = items => {
    const counts = {};
    for (const item of items) counts[item.variant_id] = (counts[item.variant_id] || 0) + item.quantity;
    return JSON.stringify(Object.entries(counts).sort());
  };
  const expected = item => {
    const properties = {...(item.properties || {})};
    for (const name of names) delete properties[name];
    if (item.dispatch.date) {
      properties[item.dispatch.property] = item.dispatch.date;
      properties._izy_dispatch_source_date = item.dispatch.source;
    }
    return properties;
  };
  const read = async () => {
    const response = await request(root() + 'cart?section_id=izy-dispatch-cart-data', {cache: 'no-store', credentials: 'same-origin'});
    if (!response.ok) throw new Error('dispatch-read');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = JSON.parse(doc.querySelector('[data-izy-cart-dispatch]')?.textContent || 'null');
    if (!Array.isArray(data?.items) || data.items.some(item => !item.key || !item.dispatch || !Number.isInteger(item.quantity))) throw new Error('dispatch-data');
    const current = await (await request(root() + 'cart.js', {cache: 'no-store', credentials: 'same-origin'})).json();
    if (!Array.isArray(current.items) || current.items.length !== data.items.length || data.items.some((item, index) => {
      const line = current.items[index];
      return line.key !== item.key || line.quantity !== item.quantity || line.variant_id !== item.variant_id;
    })) throw new Error('cart-changed');
    return {items: data.items.map((item, index) => ({...item, properties: current.items[index].properties || {}}))};
  };
  let busy = false;
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-izy-dispatch-checkout]') || event.submitter?.name !== 'checkout' || event.defaultPrevented) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    const host = form.closest('cart-drawer') || form;
    const oldInert = host.inert;
    host.inert = true;
    form.setAttribute('aria-busy', 'true');
    form.querySelector('[data-izy-dispatch-error]')?.remove();
    let changed = false;
    try {
      let data = await read();
      const limit = data.items.length + 2;
      for (let count = 0; ; count++) {
        const item = data.items.find(line => JSON.stringify(normalize(line.properties)) !== JSON.stringify(normalize(expected(line))));
        if (!item) break;
        if (count >= limit) throw new Error('dispatch-concurrent-change');
        const response = await request(root() + 'cart.js', {cache: 'no-store', credentials: 'same-origin'});
        if (!response.ok) throw new Error('cart-read');
        const current = await response.json();
        if (signature(current.items) !== signature(data.items)) throw new Error('cart-changed');
        const properties = expected(item);
        if (!Object.keys(properties).length) properties._izy_dispatch_source_date = '';
        // A write is attempted once. An uncertain response is never replayed here.
        changed = true;
        const update = await request(root() + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: item.key, quantity: item.quantity, properties})
        });
        if (!update.ok) throw new Error('cart-update');
        const updated = await update.json();
        if (quantities(updated.items) !== quantities(current.items)) throw new Error('cart-quantity-changed');
        data = await read();
      }
      if (!form.isConnected) throw new Error('cart-redrawn');
      host.inert = oldInert;
      form.removeAttribute('aria-busy');
      const checkout = document.createElement('input');
      checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = 'Checkout';
      form.append(checkout);
      // Quantities are already saved by the theme's AJAX controls. Property updates may merge lines.
      const quantityInputs = [...form.elements].filter(input => /^updates(?:\[|$)/.test(input.name) && !input.disabled);
      quantityInputs.forEach(input => input.disabled = true);
      try { HTMLFormElement.prototype.submit.call(form); }
      finally { checkout.remove(); quantityInputs.forEach(input => input.disabled = false); }
    } catch (_) {
      if (changed) document.dispatchEvent(new CustomEvent('cart:refresh'));
      showError(form);
      if (changed) location.assign(root() + 'cart?dispatch_refresh=1');
    } finally {
      host.inert = oldInert;
      form.removeAttribute('aria-busy');
      busy = false;
    }
  });
})();
